import React, {useCallback, useMemo, useState} from "react";
import {message} from "antd";
import "../../admin/AdminOrders/admin-orders.css";
import {useRequest} from "../../utils/hooks";
import {Images} from "../../images/Images";
import {GenericModal} from "../../components";
import "./company-edit-order-page.css";
import {OrderFormPanelKeys} from "../../marketplace/consts.jsx";
import {isOrderHasShippingProvider} from "../../event/utils.jsx";
import {ActivityLocationTypes} from "../../consts.js";
import {HomeDeliveryUploadMethod} from "../../marketplace/OrderLocationInput/consts.jsx";
import {EditOrderView} from "../../orders/EditOrderView/EditOrderView.jsx";
import {isEmpty} from "lodash";
import {StringBuilder} from "../../AppUtils.js";
import {openWindow} from "../../http/WindowOpener.jsx";
import EditCreatedOrderDate from "../../orders/orderModals/EditCreatedOrderDate.jsx";
import {NotifyAboutAdminOrderUpdateModal} from "../../orders/orderModals/NotifyAboutAdminOrderUpdateModal.jsx";
import {updateOrder} from "../../api/orders/systemOrders.js";
import {isCompanySubAdmin} from "../../center/EXCenterHelper";

export const priceSectionLines = [
    {
        title: "מחיר הזמנה",
        key: "offeredPrice"
    },
    {
        title: "מחיר משלוח",
        key: "deliveryPrice"
    },
    {
        title: "הנחת קוד קופון",
        key: "couponDiscountAmount"
    },
    {
        title: "הנחה כללית",
        key: "companyDiscountAmount"
    },
    {
        title: "זיכוי צד ספק",
        key: "providerDiscount"
    },
    {
        title: "טיפ",
        key: "tip",
        disabled: "יש לעדכן טיפ דרך הטופס הזמנה",
        hideIfEmpty: true
    }
];

export const SystemEditOrderPage = ({history, match}) => {
    const [notifyAboutOrderUpdateModalVisibility, setNotifyAboutOrderUpdateModalVisibility] = useState(false);
    const [formValues, setFormValues] = useState({});
    const [updatedOrderValues, setUpdatedOrderValues] = useState({});
    const [orderChangesSentToApproveModalVisibility, setOrderChangesSentToApproveModalVisibility] = useState(false);

    const [order = {}] = useRequest(
        `/api/events/${match?.params?.eventId}/orderInfo`,
        "GET",
        null,
        [],
        !!match?.params?.eventId,
        null,
        {}
    );

    const [provider, isLoadingProvider] = useRequest(
        `/api/system/providers/${order?.providerId}`,
        "get",
        null,
        [order],
        !!order?.providerId
    );

    const [userMe = {}] = useRequest(
        `/api/users/me/${order?.creatingUserId}`,
        "GET",
        null,
        [order?.creatingUserId],
        !!order?.creatingUserId,
        null,
        {}
    );

    const [companyMe = {}] = useRequest(
        `/api/companies/info/${userMe?.companyId}`,
        "GET",
        null,
        [userMe?.companyId],
        !!userMe?.companyId,
        null,
        {}
    );

    const onSaveOrder = useCallback(
        async whoToSendUpdateEmail => {
            setNotifyAboutOrderUpdateModalVisibility(false);
            const {vat, ...restUpdatedOrderValues} = updatedOrderValues;
            const {error} = await updateOrder(
                restUpdatedOrderValues,
                whoToSendUpdateEmail,
                order.updatedAt,
                "שמירת השינויים בהזמנה נכשלה"
            );

            if (error) {
                return;
            }

            setOrderChangesSentToApproveModalVisibility(true);
        },
        [updatedOrderValues, order?.updatedAt]
    );

    const onEditOrderModalBookingTimePanel = useCallback(
        createdAt => {
            setFormValues(prev => ({...prev, createdAt}));
        },
        [formValues]
    );

    const onEditOrderModalSave = useCallback(
        updatedOrder => {
            if (isNaN(parseFloat(formValues.commission))) {
                message.error("לעסקה אין עמלה, יש לנסות לעלות ולהחזיר את כמות המוצרים ולראות אם העמלה מתעדכנת");
                return;
            }

            setUpdatedOrderValues(updatedOrder);
            setNotifyAboutOrderUpdateModalVisibility(true);
        },
        [formValues]
    );

    const isExcelHomeDelivery = useMemo(
        () =>
            order?.chosenActivityLocation === ActivityLocationTypes.homeDelivery &&
            order?.homeDeliveryUploadMethod === HomeDeliveryUploadMethod.excel,
        [order?.chosenActivityLocation, order?.homeDeliveryUploadMethod]
    );

    const onCancel = useCallback(() => {
        setFormValues({});
    }, []);

    return (
        <div className="edit-order-container">
            {!isEmpty(order) && (
                <EditOrderView
                    order={order}
                    onCancel={onCancel}
                    onSave={onEditOrderModalSave}
                    priceSectionLines={priceSectionLines}
                    extraOrderFormFields={
                        <EditCreatedOrderDate date={order?.createdAt} onChange={onEditOrderModalBookingTimePanel} />
                    }
                    formValues={formValues}
                    setFormValues={setFormValues}
                    provider={provider}
                    isLoadingProvider={isLoadingProvider}
                    adminMode={true}
                    mainContact={isCompanySubAdmin(userMe) ? userMe?.firstName : companyMe?.contactName}
                    disabledFields={
                        isOrderHasShippingProvider(order) && isExcelHomeDelivery ? [OrderFormPanelKeys.Location] : []
                    }
                    businessStartHourForAdmin={4}
                    businessStartMinuteForAdmin={0}
                />
            )}
            <NotifyAboutAdminOrderUpdateModal
                visible={notifyAboutOrderUpdateModalVisibility}
                onSave={onSaveOrder}
                onClose={() => setNotifyAboutOrderUpdateModalVisibility(false)}
            />

            <GenericModal
                title={new StringBuilder("השינויים שביצעת נשלחו").append(`ל${provider?.businessName}`).toString()}
                className="company-edit-order-sure-page"
                text={["הזמנה עודכנה בהצלחה"]}
                image={Images.handshake}
                closeable={true}
                visible={orderChangesSentToApproveModalVisibility}
                onClose={() => setOrderChangesSentToApproveModalVisibility(false)}
                options={[
                    {
                        id: "accept",
                        onClick: () => openWindow(`/events/${order?.eventId}/orderV2`),
                        text: "לצפייה בהזמנה החדשה"
                    }
                ]}
            />
        </div>
    );
};
